import { useEffect, useState } from 'react';
import MainTitle from '../../../../components/template/MainTitle'
import api from '../../../../components/utils/api';
import { downloadCsv } from '../../../../components/utils/Utils';
import { DownloadIcon } from '@heroicons/react/outline';

const ThresholdModal = ({ selectedThreshold, mergeRuleId }) => {
    const [data, setData] = useState([])
    useEffect(() => {
        if (selectedThreshold && mergeRuleId) {
            api.get(`/api/merge-rules/${mergeRuleId}/thresholds/${selectedThreshold.id}`)
                .then(res => setData(res.data.values))
                .catch(err => console.error(err))
        }
    }, [selectedThreshold, mergeRuleId])

    const handleDownloadCsv = () => {
        const header = 'tag_name,threshold'
        const rows = data.map(e => `${e.tag.name},${e.value}`)
        downloadCsv(header, rows, `${selectedThreshold.name}_thresholds.csv`)
    }

    return (
        <div>
            <div className='flex items-center justify-between mt-5'>
                <MainTitle title={selectedThreshold.name} />
                <button
                    onClick={handleDownloadCsv}
                    disabled={data.length === 0}
                    className='flex items-center gap-1 p-2 text-gray-500 hover:text-gray-700 disabled:opacity-25 text-sm'
                    title='Download CSV'
                >
                    <DownloadIcon className='h-5 w-5' />
                    CSV
                </button>
            </div>
            <div className='md:grid md:grid-cols-2 gap-3 my-3'>
                {data.map((e, i) => <div key={i} className='grid grid-cols-2 items-center'>
                    <div className='text-left font-bold text-sm'>{e.tag.name}</div>
                    <div className="appearance-none w-full block bg-white text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight">{e.value}</div>
                </div>)}
            </div>
        </div>
    )
}

export default ThresholdModal